import React, { Suspense, lazy, useEffect } from 'react';
import * as R from 'ramda';
import { Route, useLocation, useHistory } from 'react-router-dom';
import { useTimezone } from '~/hooks';
import { checkIsModal, ROUTES, usePreviousNormalLocation } from '~/Routes';
import Market from './Market';
import PrivacyDialog from './PrivacyDialog';
import Header from './Header';
import Navbar from './Navbar';
import Footer from './Footer';
import { toast } from 'react-toastify';
import { useStoreState, useStoreActions } from '~/store';
import { useIntl } from 'react-intl';
import ScrollTopButton from 'Components/ScrollTopButton';
import { useNotifications } from '~/notifications';
import useTrusted from '~/trusted';
import EnvStripe from 'Components/EnvStripe';
import { RoutingTable } from '~/router';
import Tenders from './Tenders';
import Banner from './Banner';
import { useLazyRoutes } from '~/router/useLazyRoutes';

const Modals = lazy(() => import('./Modals'));

const Body = () => {
  const lazyRoutes = useLazyRoutes();
  const solution = useStoreState(state => state.auth.solution);
  const user = useStoreState(state => state.auth.user);
  const { formatMessage } = useIntl();

  const setParticipantToast = useStoreActions(
    state => state.auth.setParticipantToast
  );

  const location = useLocation();
  const history = useHistory();

  const prevLocation = usePreviousNormalLocation(location) || {
    pathname: ROUTES.home,
  };

  useTimezone(user.timezone);

  const isModal = checkIsModal(location.pathname);

  useEffect(() => {
    if (R.propOr(0, 'new_participants', solution) > 0) {
      const toastId = toast(
        formatMessage(
          {
            id: 'new-participants-toast',
            defaultMessage:
              'There {count, plural, one {is # new participant} other {are # new participants}} on the platform. Click here to review them.',
          },
          {
            count: solution.new_participants,
          }
        ),
        {
          autoClose: false,
          onClick: () => {
            history.push('/participants?dismissed=0');
          },
        }
      );
      setParticipantToast(toastId);
    }
  }, [solution]);

  const routes = [Tenders];

  return (
    <>
      <section id="content" className="main-content" role="main">
        <main
          style={{
            '--optional-text': `"${formatMessage({
              id: 'form-optional',
              defaultMessage: 'Optional',
            })}"`,
          }}
        >
          <RoutingTable
            routes={routes}
            location={isModal ? prevLocation : location}
            lazyRoutes={lazyRoutes}
          >
            <Route path={[ROUTES.home, ROUTES.marketplace]} exact>
              <Market />
            </Route>
          </RoutingTable>
        </main>
      </section>
      <Suspense fallback={null}>
        <Modals />
      </Suspense>
      <ScrollTopButton />
    </>
  );
};

export default () => {
  const solution = useStoreState(state => state.auth.solution);
  const privacyCheckReq = useStoreState(state => state.auth.privacyCheckReq);

  useNotifications();
  useTrusted();

  if (!solution) return null;

  return (
    <>
      <Header />
      <Navbar />
      <EnvStripe />
      <Banner />
      {privacyCheckReq ? <PrivacyDialog /> : <Body />}
      <Footer />
    </>
  );
};
